import "./style.css";
import icon from "./icons/icon1.png";
import icon1 from "./icons/icon1.png";
import icon2 from "./icons/icon7.png";
import icon3 from "./icons/icon9.png";
import icon4 from "./icons/icon2.png";
import icon5 from "./icons/icon8.png";
import icon6 from "./icons/icon6.png";
 import icon13 from "./icons/icon11.png";
 import icon7 from "./icons/icon13.png";
 import icon8 from "./icons/icon3.png";
 import icon11 from "./icons/icon5.png";
 import icon9 from "./icons/icon12.png";
 import icon15 from "./icons/icon5.png";
 import icon16 from "./icons/icon4.png";
 import icon17 from "./icons/icon6.png";
 import icon18 from "./icons/icon8.png";





import bigIcon from "./icons/big-icon.png";
import bgGradient from "./icons/bg-gradient.png";

function TechStack({title, desc}) {
  return (
    <div className="tech-stack">
        <div className="content">
        <div>{title}</div>
      <div>
        {desc}
      </div>
        </div>
      <div className="icons">
        <div className="left-icons">
          <div>
            <img src={icon1} />
          </div>
          <div>
            <img src={icon2} />
            <img src={icon3} />
          </div>
          <div>
            <img src={icon4} />
            <img src={icon18} />
            <img src={icon17} />
          </div>
        </div>
        <div
          className="big-icon-container"
        style={{
          backgroundImage: `url(${bgGradient})`,
          "background-size":     "cover",                     
          "background-repeat":   "no-repeat",
          "background-position": "center center" 
        }}>
        <img className="big-icon bigsicon" src={bigIcon} />

        </div>
        <div className="right-icons">
        <div>
            <img src={icon7} />
            <img src={icon8} />
            <img src={icon16} />
          </div>
          <div>
            <img src={icon13} />
            <img src={icon15} />
          </div>
          <div>
            <img src={icon9} />
          </div>
         
          
        </div>
      </div>
    </div>
  );
}

TechStack.defaultProps = {
  title: "Mobile app development technology stack",
  desc: "With a rich palette of major technologies at our fingertips, we ensure versatile, efficient, and future-proof solutions across various industry domains"
}

export default TechStack;
